import { store } from 'src/common/redux/configure-store';
import {
  closeAllTransactionSearch,
  handleTransactionSearch,
} from 'src/transaction-search/business-logic/handle-transaction-search';
import { TransactionSearchActions } from 'src/common/redux/reducers/transaction-search-reducer';
import { TransactionSearchContext } from 'src/common/interfaces/states/ITransactionSearchState';
import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { printReceipts } from 'src/devices/printer-operations';
import { CartResponse } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { checkAndGetArray } from 'src/common/helpers/array-helper';
import { searchTransactionByParam } from 'src/transaction-search/transaction-search-helper/search-finished-transactions';
import { transactionNotFoundErrorModal } from 'src/transaction-search/error-modals/search-transaction-modals';

const reprintingModalId = 'REPRINTING_MODAL';

export const handleReprintReceiptClick = async (): Promise<void> => {
  const searchParam = {
    searchContext: TransactionSearchContext.ReprintReceipt,
  };
  store.dispatch(TransactionSearchActions.setSearchParam(searchParam));
  handleTransactionSearch();
};

export const reprintLastReceipt = async (): Promise<void> => {
  return searchTransactionByParam(
    store.getState().transactionSearch,
    TransactionSearchContext.ReprintReceipt,
  ).then(result => {
    const firstTransactionFound = result.pageContent[0];
    if (firstTransactionFound) {
      handleReprintReceipt(firstTransactionFound.tlogId);
    } else {
      popupMessage(transactionNotFoundErrorModal);
    }
  });
};

export const handleReprintReceipt = async (tlogId: string): Promise<void> => {
  const handleInternalError = () => {
    popEmeraldModal(reprintingModalId);
  };
  showReprintingModal();
  return getReprintReceipt(tlogId)
    .then(async (response: CartResponse) => {
      if (response.receipts) {
        await printReceipts(checkAndGetArray(response.receipts), false, handleInternalError).catch(
          popupMessage,
        );
      }
    })
    .then(() => {
      popEmeraldModal(reprintingModalId);
      closeAllTransactionSearch();
    })
    .catch(err => {
      popEmeraldModal(reprintingModalId);
      closeAllTransactionSearch();
      popupMessage(err);
    });
};

export function getReprintReceipt(tlogId: string): Promise<CartResponse> {
  const axiosConfig: AxiosRequestConfig = {
    url: '/transaction-management/reprint-receipt',
    method: 'POST',
    data: { tlogId: tlogId },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: false,
  };
  return emeraldRequest<CartResponse>(emeraldRequestParams);
}

export const showReprintingModal = (): Promise<void> => {
  return new Promise<void>(() => {
    const messageModal: IMessageModal = {
      message: 'Reprinting Receipt',
      type: EmeraldDialogTypes.Info,
      subMessage: 'Reprint in Progress. Please wait.',
      hideButtons: true,
      modalId: reprintingModalId,
    };
    popupMessage(messageModal);
  });
};
